import { ENTITY_PAGE_PROFILE_LAYOUT_TOGGLED_WIDGETS_COUNT } from './useEntityPageProfileLayoutWidgetsExpand.constants'

export function isEntityPageProfileLayoutCollapseCommand(expandCommand) {
  return expandCommand?.isExpanded === false
}

export function hasEntityPageProfileLayoutCountedWidgets({
  collapsedWidgetsCount,
  expandedWidgetsCount,
}) {
  return collapsedWidgetsCount + expandedWidgetsCount > 0
}

export function getEntityPageProfileLayoutCountedWidgetsState({
  countChange,
  isExpanded,
  state,
}) {
  return isExpanded
    ? {
        ...state,
        expandedWidgetsCount: state.expandedWidgetsCount + countChange,
      }
    : {
        ...state,
        collapsedWidgetsCount: state.collapsedWidgetsCount + countChange,
      }
}

export function getEntityPageProfileLayoutToggledAllState(state) {
  return {
    ...state,
    expandCommand: {
      isExpanded: isEntityPageProfileLayoutCollapseCommand(state.expandCommand),
    },
  }
}

export function isEntityPageProfileLayoutToggleAllDoneByHand({
  isExpanded,
  state: { collapsedWidgetsCount, expandCommand, expandedWidgetsCount },
}) {
  const remainingWidgetsCount = isExpanded
    ? collapsedWidgetsCount
    : expandedWidgetsCount

  return (
    isExpanded === isEntityPageProfileLayoutCollapseCommand(expandCommand) &&
    remainingWidgetsCount === ENTITY_PAGE_PROFILE_LAYOUT_TOGGLED_WIDGETS_COUNT
  )
}
